<button
    type="button"
    class="custom-list-group-item btn--table-action d-flex align-items-center justify-content-center p-0 my-0 ml-0 noDetaisClick"
    placement="bottom"
    [mdbPopover]="content"
    (popoverShown)="onPopoverShown()"
    (popoverHidden)="onPopoverHidden()"
    trigger="click"
    #popover="mdbPopover"
    style="width: 36px; height: 36px;"
>
    <i class="black-text fas fa-ellipsis-h mt-0 noDetaisClick"></i>                                
</button>
<ng-template #content >
    <div class="popover-links popover-links--medium">
        <div (click)="openMerchandiseDetailsPage($event,'paid')" class="popover__action d-flex align-items-center popover__action--border cursor--pointer px-3">
            <div class="d-flex align-items-center cursor--pointer">
                <span class="body-2 cursor--pointer">Paid</span>
            </div>
        </div>

        <div (click)="openMerchandiseDetailsPage($event,'pendings')" class="popover__action d-flex align-items-center popover__action--border cursor--pointer px-3">
            <div class="d-flex align-items-center cursor--pointer">
                <span class="body-2 cursor--pointer">Pending</span>
            </div>
        </div>
        
        <div (click)="openMerchandiseDetailsPage($event,'promoCodes')" class="popover__action d-flex align-items-center popover__action--border cursor--pointer px-3">
            <div class="d-flex align-items-center cursor--pointer">
                <span class="body-2 cursor--pointer">Promo codes</span>
            </div>
        </div>

        <div (click)="openMerchandiseDetailsPage($event,'reminders')" class="popover__action d-flex align-items-center popover__action--border cursor--pointer px-3">
            <div class="d-flex align-items-center cursor--pointer">
                <span class="body-2 cursor--pointer">Reminders</span>
            </div>
        </div>
    </div>
  </ng-template>